import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DialogRef, DialogService } from "@progress/kendo-angular-dialog";
import { environment } from "environments/environment";
import { CommonService } from "app/reusable/common.service";
import { CedNotificationService } from "ced-ng-library";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ResetState } from "app/_actions/intake.actions";
import { Store } from "@ngxs/store";

@Component({
    selector: 'app-case-type-change-list',
    templateUrl: './case-type-list.component.html'
})
export class CaseTypelistComponent implements OnInit, OnDestroy {

    fromCaseTypes = [];
    toCaseTypes = [];
    getDossierCaseTypes: string = `CaseType/GetDossierCaseTypes/`;
    getLinkedCaseTypes: string = `CaseType/getLinkedCaseTypes/`;
    caseTypeListForm: FormGroup;
    private _subject$: Subject<boolean> = new Subject();
    dossierId: string;
    public serverUrlSlot3 : string = environment.Services.AlphaURLSlot3;

    constructor(private dialog: DialogRef,    private store: Store,

        private commonService: CommonService,
        private cedNotificationService: CedNotificationService) { }


    ngOnInit(): void {
        this.initForm();
        this.getFromCaseTypes();
    }

    initForm() {
        this.caseTypeListForm = new FormGroup({
            toCaseTypes: new FormControl("", Validators.required),
            fromCaseTypes: new FormControl("", Validators.required)
        });
    }
    getFromCaseTypes() {
        this.commonService.getData(this.getDossierCaseTypes + this.dossierId, this.serverUrlSlot3)
            .pipe(takeUntil(this._subject$))
            .subscribe(
                (data: any) => {
                    this.fromCaseTypes = data;
                },
                (error) => {
                    this.cedNotificationService.error("NOTIFICATIONS.GET_CASE");
                });
    }

    public onFromCaseTypeChange() {
        let fromCaseType = this.caseTypeListForm.controls.fromCaseTypes.value;
        if (fromCaseType != undefined) {
            this.commonService.getData(this.getLinkedCaseTypes + fromCaseType.ctyId, this.serverUrlSlot3)
                .pipe(takeUntil(this._subject$))
                .subscribe(
                    (data: any) => {
                        data.forEach(caseType => {
                            caseType.ctyHasTravelStep = caseType.ctyHasTravelDetails;
                            this.toCaseTypes.push(caseType);
                        });
                    },
                    (error) => {
                        this.cedNotificationService.error("NOTIFICATIONS.GET_CASE");
                    });
        }

    }

    copyDossier() {
        if (!this.caseTypeListForm.valid) {
            this.cedNotificationService.error("NOTIFICATIONS.REQUIRED_DATA_MISSING")
            return;
        }
        this.store.dispatch(new ResetState()).pipe(takeUntil(this._subject$)).subscribe();
        this.dialog.close(this.caseTypeListForm.controls.toCaseTypes.value);
    }

    cancel() {
        this.dialog.close();
    }

    ngOnDestroy(): void {
        this._subject$.next();
        this._subject$.complete();
    }
}